import React from 'react';
import moduleStyles from './dance-ai-score.module.scss';
import classNames from 'classnames';
export var ScoreColors;
(function (ScoreColors) {
    // A grey bar with no symbol in the symbol container yet.
    ScoreColors["GREY"] = "grey";
    // A green bar with a green check symbol.
    ScoreColors["YES"] = "yes";
    // A red bar with a red cross symbol.
    ScoreColors["NO"] = "no";
    // A tri-colored bar with a green check symbol.
    ScoreColors["NORMAL_YES"] = "normal_yes";
    // A tri-colored bar with no symbol container or symbol.
    ScoreColors["NORMAL_NO"] = "normal_no";
})(ScoreColors || (ScoreColors = {}));
// Scale max bar size to be 90% of the total height of visualization.
var SCORE_VISUALIZATION_HEIGHT = 140 * 0.9;
var NOTCH_OFFSET = 140 * 0.1;
var DanceAiScore = function (_a) {
    var scores = _a.scores, minMax = _a.minMax, colors = _a.colors, slotCount = _a.slotCount;
    // For each score we wish to visualize, we subtract the minimum score
    // in the observed data in order to generate a "net score"
    // and better differentiate between observed scores.
    var getSummedNetScore = function (scores) {
        return scores.reduce(function (scaledSum, score) {
            return (scaledSum += score - minMax.minIndividualScore);
        }, 0);
    };
    var getHeight = function (scores) {
        var summedNetScore = getSummedNetScore(scores);
        var maxSummedNetScore = minMax.maxTotalScore - minMax.minIndividualScore * slotCount;
        return Math.round((summedNetScore / maxSummedNetScore) * SCORE_VISUALIZATION_HEIGHT);
    };
    var getLayerClassName = function (layerColor) {
        return colors === ScoreColors.NORMAL_YES || colors === ScoreColors.NORMAL_NO
            ? layerColor
            : colors === ScoreColors.GREY
                ? moduleStyles.barFillGrey
                : colors === ScoreColors.YES
                    ? moduleStyles.barFillYes
                    : moduleStyles.barFillNo;
    };
    var layers = [
        {
            height: getHeight(scores),
            className: getLayerClassName(moduleStyles.barFillFirst),
        },
        {
            height: getHeight([scores[0], scores[1]]),
            className: getLayerClassName(moduleStyles.barFillSecond),
        },
        {
            height: getHeight([scores[0]]),
            className: getLayerClassName(moduleStyles.barFillThird),
        },
    ];
    return (React.createElement("div", { className: moduleStyles.scoreContainer },
        layers.map(function (layer, index) {
            return (React.createElement("div", { key: index, className: moduleStyles.barContainer, style: {
                    height: layer.height,
                } },
                React.createElement("div", { className: classNames(moduleStyles.barFill, layer.className) })));
        }),
        React.createElement("div", { className: moduleStyles.notchContainer, style: { top: NOTCH_OFFSET } },
            colors !== ScoreColors.NORMAL_NO && (React.createElement("div", { className: moduleStyles.resultContainer },
                (colors === ScoreColors.NORMAL_YES ||
                    colors === ScoreColors.YES) && (React.createElement("div", { className: classNames(moduleStyles.resultContent, moduleStyles.resultContentYes) },
                    React.createElement("i", { className: "fa fa-check-circle" }))),
                colors === ScoreColors.NO && (React.createElement("div", { className: classNames(moduleStyles.resultContent, moduleStyles.resultContentNo) },
                    React.createElement("i", { className: "fa fa-times-circle" }))))),
            React.createElement("div", { className: classNames(moduleStyles.notch, colors === ScoreColors.NORMAL_NO && moduleStyles.notchNormalNo) }))));
};
export default DanceAiScore;
